import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoginState, LoginStateConext, AuthUserProvider } from "./context/AuthContext";
import { TitleContext, TitleParamContext } from './context/TitleContext';
import { RegisterPageContextState, RegisterPageContext } from './context/RegisterPageTypeContext';
import { RegisterUser } from "./view/userregister/RegisterUser";
import { ConsentForm } from "./view/userregister/ConsentForm";
import { Confirm } from "./view/userregister/Confirm";
import { Complete } from "./view/userregister/Complete";
import { RegisterEmail } from "./view/userregister/RegisterEmail";
import { CompleteRegister } from "./view/userregister/CompleteRegister";
import { RegisterTrialLicense, TrialRedirect } from "./view/userregister/RegisterTrialLicense";
import { Login } from './view/Login';
import { Main } from './view/Main';
import { ScrrenTitle } from './components/ScreenTitle';
import { MyPage } from './view/user/usermanage/MyPage';
import { ChangeUserName } from "./view/user/usermanage/ChangeUserName";
import { ChangePassword } from "./view/user/usermanage/ChangePassword";
import { ChangeMailAddress } from "./view/user/usermanage/ChangeMailaddress";
import { ForgetPassword } from "./view/user/usermanage/ForgetPassword";
import { ForgetPasswordChange } from "./view/user/usermanage/ForgetPasswordChange";
import { Inquiry } from "./view/support/Inquiry";
import { Receipt } from './view/user/usermanage/Receipt';
import { Confirmation } from "./view/support/Confirmation";
import { NewLicense } from "./view/license/Newlicense";
import { ContinueLicense } from "./view/license/ContinueLicense";
import { PaymentConfirm } from "./view/license/Paymentconfirm";
import { PurchaseComplete, TrialComplete } from "./view/license/PurchaseComplete";
import { Message } from "./view/Message";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { PayPalScriptOptions } from '@paypal/paypal-js';
import { ChangeMailAddressComp } from './view/user/usermanage/ChangeMailaddressComplete';
import { ScrollTop } from './components/ScrollToTop';
import { Supportchat } from './view/support/Supportchat';
import { AddTrialLicense } from './view/license/AddTrialLicense';
import { CompleteTrialUser } from './view/userregister/CompleteTrialUser';
import { CompleteTrialUserLicense } from './view/license/CompleteTrialUserLicense';


    export const SCRIPT_PROVIDER_OPTIONS: PayPalScriptOptions = {
        "client-id": process.env.REACT_APP_PAYPAL_CLIENTID ?? "AXo7ibME1ViraA0g-ibyvggTI6C6Nz13Z75E5eecxXAYOkpNrQVegqh_DUhU8xe-D5kaYRPCngAX-UCY",
        currency: "JPY",
        locale: "ja_JP",
        "disable-funding": "card",
    }

    export default function App() {

        const ctx = LoginState();
        const title = TitleContext();
        const regiterPageTypeState = RegisterPageContextState();

        useEffect(() => {
            ctx.checkLoginState();
        }, []);

        return (
            <LoginStateConext.Provider value={ctx} >
                <TitleParamContext.Provider value={title}>
                    <RegisterPageContext.Provider value={regiterPageTypeState}>
                        <PayPalScriptProvider options={SCRIPT_PROVIDER_OPTIONS}>
                            <BrowserRouter basename="/support">
                                <ScrollTop/>
                                <Routes>
                                    <Route path="/" element={<ScrrenTitle title="サポート・製品購入" />}>
                                        <Route index element={<AuthUserProvider component={<MyPage />} redirect="/Main" loginStateinfo={ctx} />} />
                                        <Route path="mypage">
                                            <Route index element={
                                                <AuthUserProvider component={<MyPage />} redirect="/Login" loginStateinfo={ctx} />
                                            } />
                                            <Route path="changeusername">
                                                <Route index element={
                                                    <AuthUserProvider component={<ChangeUserName />} redirect="/Login" loginStateinfo={ctx} />
                                                } />
                                                <Route path="message">
                                                    <Route index element={
                                                        <AuthUserProvider component={<Message />} redirect="/Login" loginStateinfo={ctx} />
                                                    } />
                                                </Route>
                                            </Route>
                                            <Route path="changepassword">
                                                <Route index element={
                                                    <AuthUserProvider component={<ChangePassword />} redirect="/Login" loginStateinfo={ctx} />
                                                } />
                                                <Route path="message">
                                                    <Route index element={
                                                        <AuthUserProvider component={<Message />} redirect="/Login" loginStateinfo={ctx} />
                                                    } />
                                                </Route>
                                            </Route>
                                            <Route path="changemailaddress">
                                                <Route index element={
                                                    <AuthUserProvider component={<ChangeMailAddress />} redirect="/Login" loginStateinfo={ctx} />
                                                } />
                                                <Route path="message">
                                                    <Route index element={
                                                        <AuthUserProvider component={<Message />} redirect="/Login" loginStateinfo={ctx} />
                                                    } />
                                                </Route>
                                            </Route>
                                            <Route path="newlicense">
                                                <Route index element={
                                                    <AuthUserProvider component={<NewLicense />} redirect="/Login" loginStateinfo={ctx} />
                                                } />
                                                <Route path="paymentconfirm">
                                                    <Route index element={
                                                        <AuthUserProvider component={<PaymentConfirm />} redirect="/Login" loginStateinfo={ctx} />
                                                    } />
                                                    <Route path="purchasecomplete">
                                                        <Route index element={
                                                            <AuthUserProvider component={<PurchaseComplete />} redirect="/Login" loginStateinfo={ctx} />
                                                        } />
                                                    </Route>
                                                </Route>
                                            </Route>

                                            <Route path="continuelicense">
                                                <Route index element={
                                                    <AuthUserProvider component={<ContinueLicense />} redirect="/Login" loginStateinfo={ctx} />
                                                } />
                                                <Route path="paymentconfirm">
                                                    <Route index element={
                                                        <AuthUserProvider component={<PaymentConfirm />} redirect="/Login" loginStateinfo={ctx} />
                                                    } />
                                                    <Route path="purchasecomplete">
                                                        <Route index element={
                                                            <AuthUserProvider component={<PurchaseComplete />} redirect="/Login" loginStateinfo={ctx} />
                                                        } />
                                                    </Route>
                                                </Route>
                                            </Route>

                                            <Route path="receipt">
                                                <Route index element={
                                                    <AuthUserProvider component={<Receipt />} redirect="/Login" loginStateinfo={ctx} />
                                                } />
                                            </Route>

                                            <Route path="trial">
                                                <Route index element={
                                                    <AuthUserProvider component={<AddTrialLicense />} redirect="/Login" loginStateinfo={ctx} />
                                                } />
                                                <Route path="trialcomplete">
                                                    <Route index element={
                                                        <AuthUserProvider component={<TrialComplete />} redirect="/Login" loginStateinfo={ctx} />
                                                    } />
                                                </Route>
                                            </Route>

                                            <Route path="inquiry">
                                                <Route index element={
                                                    <AuthUserProvider component={<Inquiry />} redirect="/Login" loginStateinfo={ctx} />
                                                } />
                                                <Route path="confirmation">
                                                    <Route index element={
                                                        <AuthUserProvider component={<Confirmation />} redirect="/Login" loginStateinfo={ctx} />
                                                    } />
                                                    <Route path="complete">
                                                        <Route index element={
                                                            <AuthUserProvider component={<Message />} redirect="/Login" loginStateinfo={ctx} />
                                                        } />
                                                    </Route>
                                                </Route>
                                            </Route>
                                        </Route>

                                        <Route path="changemailaddresscomp">
                                            <Route index element={<ChangeMailAddressComp />} />
                                        </Route>

                                        <Route path="main">
                                            <Route index element={<Main />} />
                                        </Route>
                                        <Route path="login">
                                            <Route index element={
                                                <AuthUserProvider component={<Login />} redirect="/Login" loginStateinfo={ctx} />
                                            } />
                                        </Route>
                                        <Route path="forgetpassword">
                                            <Route index element={<ForgetPassword />} />
                                            <Route path="Message">
                                                <Route index element={<Message />} />
                                            </Route>
                                        </Route>
                                        <Route path="forgetpasswordchange">
                                            <Route index element={<ForgetPasswordChange />} />
                                            <Route path="Message">
                                                <Route index element={<Message />} />
                                            </Route>
                                        </Route>

                                        <Route path="trial" element={<TrialRedirect /> }>

                                        </Route>

                                        <Route path="consentform">
                                            <Route index element={<ConsentForm />} />
                                            <Route path="registeruser">
                                                <Route index element={<RegisterUser />} />
                                                <Route path="confirm">
                                                    <Route index element={<Confirm />} />
                                                    <Route path="complete">
                                                        <Route index element={<Complete />} />
                                                    </Route>
                                                </Route>
                                            </Route>
                                            <Route path="trial">
                                                <Route index element={<RegisterTrialLicense />} />
                                                <Route path="complete" element={<Message />}></Route>
                                            </Route>
                                        </Route>
                                        <Route path="registeremail">
                                            <Route index element={<RegisterEmail />} />
                                            <Route path="completeregister">
                                                <Route index element={<CompleteRegister />} />                                                
                                            </Route>                                            
                                        </Route>

                                        <Route path="registertrialuser">
                                            <Route index element={<CompleteTrialUser /> } />
                                        </Route>
                                        <Route path="completetrialuser">
                                            <Route index element={
                                                <AuthUserProvider component={<TrialComplete />} redirect="/Login" loginStateinfo={ctx} />
                                            }></Route>
                                            {/*
                                            <Route path="complete">
                                                <Route index element={<AuthUserProvider component={<CompleteTrialUserLicense />} redirect="/Login" loginStateinfo={ctx} />} />
                                            </Route>
                                            */}
                                        </Route>

                                        <Route path="supportchat">
                                            <Route index element={<Supportchat />} />
                                        </Route>

                                        <Route path="*" element={<div>404　ページが見つかりません。</div>}></Route>
                                    </Route>
                                </Routes>
                            </BrowserRouter>
                        </PayPalScriptProvider>
                    </RegisterPageContext.Provider>
                </TitleParamContext.Provider>
            </LoginStateConext.Provider>

        );
    }
